import { Box, Button } from '@mui/material';

import { useLocale } from '@shared/hooks/locale';

type StepperFooterProps = {
  onBack: () => void;
  showBack: boolean;
  isLastStep: boolean;
  isLoading: boolean;
  nextLabel?: string;
  backLabel?: string;
  onNext?: () => void;
};

export const StepperFooter: React.FC<StepperFooterProps> = ({
  onBack,
  showBack,
  isLastStep,
  isLoading,
  nextLabel,
  backLabel,
  onNext,
}) => {
  const { t } = useLocale();

  const buttonLabel = nextLabel ?? (isLastStep ? t('Finish') : t('Next'));

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        py: 1,
        px: 2,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Button
        onClick={onBack}
        disabled={isLoading}
        sx={{ visibility: showBack ? 'visible' : 'hidden' }}
      >
        {backLabel ?? t('Back')}
      </Button>

      <Button
        type={onNext ? 'button' : 'submit'}
        onClick={onNext}
        variant="contained"
        loading={isLoading}
        loadingPosition="end"
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};
